import { Modal } from "react-bootstrap";
import TitleDetailsList from "containers/property/TitleDetailsList";

function TitleDetailsModal({
    show,
    isAuthenticated,
    user,
    updateTableState,
    filter,
    saveForm,
    data,
    dataFetch,
    saveRecord,
    deleteRecord,
    onClose,
    validateRelatedRecord,
    streetOptions,
    context,
    stateCode,
}) {

    return (
        <Modal id="property-title-details-modal" show={show} onHide={onClose} dialogClassName="property-table-modal-wide">
            <Modal.Header closeButton>
                <Modal.Title>Parcels</Modal.Title>
            </Modal.Header>
            <Modal.Body id="property-title-details-modal-body" style={{ overflowX: "scroll" }}>
                <TitleDetailsList
                    filter={filter}
                    isAuthenticated={isAuthenticated}
                    isLoading={false}
                    controlType="table"
                    saveForm={saveForm}
                    user={user}
                    data={data}
                    dataFetch={dataFetch}
                    updateTableState={updateTableState}
                    saveRecord={saveRecord}
                    deleteRecord={deleteRecord}
                    validateRelatedRecord={validateRelatedRecord}
                    streetOptions={streetOptions}
                    context={context}
                    stateCode={stateCode}
                />
            </Modal.Body>
        </Modal>
    );
}
export default TitleDetailsModal;